import { useEffect, useState } from "react";
import {
  Button,
  FormField,
  Modal,
  SelectInput,
  TextAreaInput,
  TextInput,
} from "../../components/ui";
import { dataCompleta } from "../GestaoPonto/pontoUtils";

const TIPOS = [
  { valor: "INCLUIR", rotulo: "Esqueci de bater um horário" },
  { valor: "CORRIGIR", rotulo: "Um horário está errado" },
  { valor: "REMOVER", rotulo: "Bati a mais / sem querer" },
];

/**
 * Pedido de ajuste da colaboradora. Nada muda no cartão até a gestão aprovar.
 */
const SolicitarAjusteModal = ({ dia, enviando, onCancelar, onEnviar }) => {
  const registros = dia?.registros || [];
  const [form, setForm] = useState({
    tipo: "INCLUIR",
    marcacaoId: "",
    horario: "",
    motivo: "",
  });

  useEffect(() => {
    setForm({ tipo: "INCLUIR", marcacaoId: "", horario: "", motivo: "" });
  }, [dia]);

  const precisaMarcacao = form.tipo !== "INCLUIR";
  const precisaHorario = form.tipo !== "REMOVER";
  const valido =
    form.motivo.trim().length >= 5 &&
    (!precisaMarcacao || form.marcacaoId) &&
    (!precisaHorario || form.horario);

  const alterarTipo = (tipo) =>
    setForm({ ...form, tipo, marcacaoId: "", horario: "" });

  const enviar = () =>
    onEnviar({
      data: dia.data,
      tipo: form.tipo,
      marcacaoId: precisaMarcacao ? form.marcacaoId : null,
      horario: precisaHorario ? form.horario : null,
      motivo: form.motivo.trim(),
    });

  return (
    <Modal
      open={Boolean(dia)}
      onClose={onCancelar}
      title="Solicitar ajuste do ponto"
      description={dia ? `${dia.diaSemana}, ${dataCompleta(dia.data)}` : null}
      className="max-w-md"
    >
      {dia && (
        <div className="space-y-4">
          <fieldset className="space-y-2">
            <legend className="mb-1 text-sm font-medium text-gray-700">
              O que aconteceu?
            </legend>
            {TIPOS.map((tipo) => {
              const semMarcacao = tipo.valor !== "INCLUIR" && !registros.length;
              return (
                <label
                  key={tipo.valor}
                  className={`flex items-center gap-2 rounded-md border px-3 py-2 text-sm ${
                    form.tipo === tipo.valor
                      ? "border-blue-500 bg-blue-50"
                      : "border-gray-200"
                  } ${semMarcacao ? "opacity-50" : "cursor-pointer"}`}
                >
                  <input
                    type="radio"
                    name="tipo-ajuste"
                    value={tipo.valor}
                    checked={form.tipo === tipo.valor}
                    disabled={semMarcacao}
                    onChange={() => alterarTipo(tipo.valor)}
                  />
                  {tipo.rotulo}
                </label>
              );
            })}
          </fieldset>

          {precisaMarcacao && (
            <FormField
              label={
                form.tipo === "REMOVER"
                  ? "Marcação a remover"
                  : "Marcação a corrigir"
              }
              htmlFor="ajuste-marcacao"
              required
            >
              <SelectInput
                id="ajuste-marcacao"
                value={form.marcacaoId}
                onChange={(evento) =>
                  setForm({ ...form, marcacaoId: evento.target.value })
                }
              >
                <option value="">Selecione</option>
                {registros.map((registro) => (
                  <option key={registro.id} value={registro.id}>
                    {registro.horario}
                  </option>
                ))}
              </SelectInput>
            </FormField>
          )}

          {precisaHorario && (
            <FormField
              label={
                form.tipo === "INCLUIR"
                  ? "Horário que faltou"
                  : "Horário correto"
              }
              htmlFor="ajuste-horario"
              required
            >
              <TextInput
                id="ajuste-horario"
                type="time"
                value={form.horario}
                onChange={(evento) =>
                  setForm({ ...form, horario: evento.target.value })
                }
              />
            </FormField>
          )}

          <FormField
            label="Motivo"
            htmlFor="ajuste-motivo"
            required
            hint="Ex.: esqueci de bater a volta do almoço."
          >
            <TextAreaInput
              id="ajuste-motivo"
              maxLength={500}
              value={form.motivo}
              onChange={(evento) =>
                setForm({ ...form, motivo: evento.target.value })
              }
            />
          </FormField>

          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={onCancelar}>
              Cancelar
            </Button>
            <Button loading={enviando} disabled={!valido} onClick={enviar}>
              Enviar para a gestão
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default SolicitarAjusteModal;
